/* ==========================================================================
   brand-motion.js — GSAP motion runtime
   Loaded after gsap.min.js / scrolltrigger.min.js / splittext.min.js.

   Owns three things the theme editor and Safari otherwise break:
     1. section lifecycle  — gsap.context() per section, reverted on unload
     2. reduced motion     — gsap.matchMedia(), movement dropped, fades kept
     3. refresh timing     — fonts + images settle before triggers measure
   ========================================================================== */

(function () {
  'use strict';

  if (!window.gsap) return;

  gsap.registerPlugin(ScrollTrigger, SplitText);

  gsap.defaults({ duration: 0.6, ease: 'power2.out' });

  // Bebas is condensed and metric-heavy; triggers measured before it lands are wrong.
  if (document.fonts) {
    document.fonts.ready.then(function () {
      ScrollTrigger.refresh();
    });
  }

  var contexts = new Map();

  var Motion = {
    /* Register a section's animations. `build` runs inside a gsap.context scoped
       to the section root, and inside matchMedia so it auto-reverts on teardown.

       build(mm, root, reduced) — call mm.add() inside for breakpoint work, or use
       the `reduced` flag for the simple case. */
    section: function (id, root, build) {
      if (!root) return;
      Motion.destroy(id);

      var ctx = gsap.context(function () {
        var mm = gsap.matchMedia();

        mm.add(
          {
            motion: '(prefers-reduced-motion: no-preference)',
            reduced: '(prefers-reduced-motion: reduce)',
            desktop: '(min-width: 750px)',
            mobile: '(max-width: 749px)',
          },
          function (context) {
            // Propagate build's cleanup so matchMedia runs it on revert
            return build(context.conditions, root);
          }
        );
      }, root);

      contexts.set(id, ctx);
    },

    destroy: function (id) {
      var ctx = contexts.get(id);
      if (ctx) {
        ctx.revert();
        contexts.delete(id);
      }
    },

    /* Split a heading into masked lines. Returns the line elements.
       Masking wrapper is what makes yPercent:110 read as "rising out of nothing". */
    lines: function (el) {
      if (!el) return [];
      var split = new SplitText(el, {
        type: 'lines',
        linesClass: 'motion-line',
        mask: 'lines',
      });
      return split.lines;
    },

    /* Standard section reveal. Skills: y:40, 0.8s, power3.out, top 80%, once. */
    reveal: function (targets, reduced, vars) {
      var opts = vars || {};
      if (!targets || (targets.length === 0 && !targets.nodeType)) return;

      var from = reduced
        ? { autoAlpha: 0 }
        : { autoAlpha: 0, y: opts.y != null ? opts.y : 40 };

      return gsap.from(targets, Object.assign(from, {
        duration: reduced ? 0.2 : 0.8,
        ease: 'power3.out',
        stagger: reduced ? 0 : opts.stagger != null ? opts.stagger : 0.06,
        scrollTrigger: {
          trigger: opts.trigger || targets,
          start: 'clamp(top 80%)',
          once: true,
        },
      }));
    },
  };

  window.BrandMotion = Motion;

  /* Theme editor: sections re-render on every settings change. Without this the
     old ScrollTriggers keep measuring detached DOM and pinning goes haywire. */
  document.addEventListener('shopify:section:unload', function (e) {
    Motion.destroy(e.detail.sectionId);
  });

  document.addEventListener('shopify:section:select', function () {
    ScrollTrigger.refresh();
  });
})();
